export const DUPLICATE_GROUPS_HERE_REQUEST =
  'app/EditSessionPage/DUPLICATE_GROUPS_HERE_REQUEST';
export const DUPLICATE_GROUPS_HERE_SUCCESS =
  'app/EditSessionPage/DUPLICATE_GROUPS_HERE_SUCCESS';
export const DUPLICATE_GROUPS_HERE_ERROR =
  'app/EditSessionPage/DUPLICATE_GROUPS_HERE_ERROR';

export const DUPLICATE_GROUPS_INTERNALLY_REQUEST =
  'app/EditSessionPage/DUPLICATE_GROUPS_INTERNALLY_REQUEST';
export const DUPLICATE_GROUPS_INTERNALLY_SUCCESS =
  'app/EditSessionPage/DUPLICATE_GROUPS_INTERNALLY_SUCCESS';
export const DUPLICATE_GROUPS_INTERNALLY_ERROR =
  'app/EditSessionPage/DUPLICATE_GROUPS_INTERNALLY_ERROR';

export const GROUP_QUESTIONS_REQUEST =
  'app/EditSessionPage/GROUP_QUESTIONS_REQUEST';
export const GROUP_QUESTIONS_SUCCESS =
  'app/EditSessionPage/GROUP_QUESTIONS_SUCCESS';
export const GROUP_QUESTIONS_ERROR =
  'app/EditSessionPage/GROUP_QUESTIONS_ERROR';

export const SHARE_GROUPS_EXTERNALLY_REQUEST =
  'app/EditSessionPage/SHARE_GROUPS_EXTERNALLY_REQUEST';
export const SHARE_GROUPS_EXTERNALLY_SUCCESS =
  'app/EditSessionPage/SHARE_GROUPS_EXTERNALLY_SUCCESS';
export const SHARE_GROUPS_EXTERNALLY_ERROR =
  'app/EditSessionPage/SHARE_GROUPS_EXTERNALLY_ERROR';

export const UPDATE_QUESTION_GROUP_REQUEST =
  'app/EditSessionPage/UPDATE_QUESTION_GROUP_REQUEST';
export const UPDATE_QUESTION_GROUP_SUCCESS =
  'app/EditSessionPage/UPDATE_QUESTION_GROUP_SUCCESS';
export const UPDATE_QUESTION_GROUP_ERROR =
  'app/EditSessionPage/UPDATE_QUESTION_GROUP_ERROR';

export const CHANGE_GROUP_NAME_REQUEST =
  'app/EditSessionPage/CHANGE_GROUP_NAME_REQUEST';
export const CHANGE_GROUP_NAME_SUCCESS =
  'app/EditSessionPage/CHANGE_GROUP_NAME_SUCCESS';
export const CHANGE_GROUP_NAME_ERROR =
  'app/EditSessionPage/CHANGE_GROUP_NAME_ERROR';

export const GET_QUESTION_GROUPS_REQUEST =
  'app/EditSessionPage/GET_QUESTION_GROUPS_REQUEST';
export const GET_QUESTION_GROUPS_SUCCESS =
  'app/EditSessionPage/GET_QUESTION_GROUPS_SUCCESS';
export const GET_QUESTION_GROUPS_ERROR =
  'app/EditSessionPage/GET_QUESTION_GROUPS_ERROR';

export const REORDER_GROUP_LIST_REQUEST =
  'app/EditSessionPage/REORDER_GROUP_LIST_REQUEST';
export const REORDER_GROUP_LIST_SUCCESS =
  'app/EditSessionPage/REORDER_GROUP_LIST_SUCCESS';
export const REORDER_GROUP_LIST_ERROR =
  'app/EditSessionPage/REORDER_GROUP_LIST_ERROR';

export const CLEAN_GROUPS = 'app/EditSessionPage/CLEAN_GROUPS';

export const SAVED_ACTIONS = [
  GET_QUESTION_GROUPS_SUCCESS,
  GET_QUESTION_GROUPS_ERROR,
  CHANGE_GROUP_NAME_ERROR,
  CHANGE_GROUP_NAME_SUCCESS,
  SHARE_GROUPS_EXTERNALLY_SUCCESS,
  SHARE_GROUPS_EXTERNALLY_ERROR,
  GROUP_QUESTIONS_SUCCESS,
  GROUP_QUESTIONS_ERROR,
  DUPLICATE_GROUPS_HERE_ERROR,
  DUPLICATE_GROUPS_HERE_SUCCESS,
  REORDER_GROUP_LIST_SUCCESS,
  REORDER_GROUP_LIST_ERROR,
];

export const SAVING_ACTIONS = [
  GET_QUESTION_GROUPS_REQUEST,
  GROUP_QUESTIONS_REQUEST,
  DUPLICATE_GROUPS_HERE_REQUEST,
  SHARE_GROUPS_EXTERNALLY_REQUEST,
  CHANGE_GROUP_NAME_REQUEST,
  REORDER_GROUP_LIST_REQUEST,
];
